<template>
	<div class="relative max-w-full" :class="{'bg-gray-150': backgroundColor}">
		<slider v-if="!$slots.default" v-model="visibleIndex" :show-arrows="imageItems.length > 1"
				:visible-arrows="slidesPerView < imageItems.length"
				:disable-touch="slidesPerView >= imageItems.length"
				:show-pagination="showPagination"
				:slides-per-view="slidesPerView">
			<slider-item v-for="(image, mediaIndex) in imageItems" :value="mediaIndex" :key="mediaIndex">
				<cdn-image :src="image.preview && image.preview.path ? image.preview.path : image.path"
						   class="cursor-pointer m-auto"
						   :class="itemClass"
						   :background-color="backgroundColor"
						   :rounded="rounded"
						   :size="image.preview && image.preview.size ? image.preview.size : image.size"
						   :alt="image.preview && image.preview.title ? image.preview.title : image.title"
						   @click="openIndex(mediaIndex)"/>
			</slider-item>
		</slider>
		<div v-else class="cursor-pointer" @click="isActive = true">
			<slot/>
		</div>

		<modal v-if="imageItems.length" v-model="isActive" no-padding large>
			<slider v-model="visibleIndex" class="w-full h-full" with-keyboard-navigation :slides-per-view="1" :show-arrows="imageItems.length > 1"
					:disable-touch="imageItems.length <= 1" visible-arrows fill>
				<slider-item v-for="(image, i) in imageItems" :key="`modal-item-${i}`" :value="i" class="flex items-center">
					<cdn-image :src="image.path"
							   class="cursor-pointer m-auto"
							   :size="image.size ? image.size : {width: '100vw', sm: {height: 400}, lg: {height: 600}, xl: {height: 600}}"
							   :alt="image.title"
							   @click="isActive = true"/>

					<div v-if="downloadable && image._key" class="my-5">
						<form-btn :action="`/media/files/${image._key}/download`"
								  method="get"
								  @success="$downloadFile">
							<Icon :icon="icons.download"/>
							<span>{{ $t('action.download') }}</span>
						</form-btn>
					</div>

				</slider-item>
			</slider>
			<template #footer>
				<div v-if="visibleIndex !== null && imageItems[visibleIndex]?.title" class="p-16">
					<p class="mb-0 text-center text-sm">{{ imageItems[visibleIndex].title }}</p>
				</div>
			</template>
			<template #button>
				<slot name="button"/>
			</template>
		</modal>
	</div>
</template>

<script>
import Toggleable from "../../mixins/Toggleable";
import {downloadIcon} from "../../config";

export default {
	name: 'ImageModal',

	mixins: [Toggleable],

	emits: ['update:index'],

	props: {

		// The default media index to display
		index: {
			default: null
		},

		// The sources of the images to show
		src: {
			type: [Array, Object],
			default: null
		},

		// States if the media can be downloaded
		downloadable: {
			type: Boolean,
			default: false
		},

		// Whether navigation dots shall be displayed on the preview
		showPagination: {
			type: Boolean,
			default: false
		},

		// Whether a border radius shall be applied on the preview image
		rounded: {
			type: Boolean,
			default: false
		},

		// Number of slides per view (slides visible at the same time on slider's container).
		slidesPerView: {
			type: Number,
			default: 1
		},

		// The background color to use (or true for a slight gray) when the contained image does not fit the aspect ratio
		backgroundColor: {
			type: Boolean,
			default: false
		},

		itemClass: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			visibleIndex: this.index,
			items: [],
			icons: {
				download: downloadIcon,
			}
		}
	},

	computed: {
		imageItems() {
			return Array.isArray(this.src) ? this.src : [this.src];
		}
	},

	watch: {
		index(index) {
			this.visibleIndex = index;
		},

		visibleIndex(value) {
			this.$emit('update:index', value)
		},
	},

	methods: {
		openIndex(index) {
			this.visibleIndex = index;
			this.isActive = true;
		}
	}
}
</script>